import React, {Component} from "react";
import {Field, Form, Formik, FormikHelpers} from "formik";
import * as channelActions from "../../actions/channelActions";
import TitleHelper from "../shared/TitleHelper";
import {IFormProps} from "../../interfaces/interfaces";
import store from "../../store";
import {Button, Form as FormStyled} from "semantic-ui-react";
import FormError from "../shared/forms/FormError";

class DeleteChannel extends Component<IFormProps, DeleteChannelFormValues> {
    constructor(props : any){
        super(props);
        this.state = {
            idChannel: ""
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    componentDidMount(): void {
        if (this.props.initalValues !== undefined) {
            this.setState(this.props.initalValues);
        }
    }
    onCancel(): void {
        store.dispatch(channelActions.backToList());
    }

    handleSubmit(values : DeleteChannelFormValues, actions : FormikHelpers<DeleteChannelFormValues>) : void {
        store.dispatch(channelActions.deleteChannel(values.idChannel));
    }

    render(): React.ReactNode {
        return (
            <div className="form-wrapper">
                <TitleHelper title="Channel löschen"/>
                <h2>Channel löschen</h2>
                <Formik enableReinitialize initialValues={this.state} onSubmit={this.handleSubmit}>
                    <Form className="form">
                        <br/>
                        <FormStyled>
                            <FormStyled.Field>
                                <label htmlFor="idChannel">Channel ID</label>
                                <Field type="hidden" name="idChannel"/>
                                <p>{this.state.idChannel}</p>
                                <FormError name="idChannel" />
                            </FormStyled.Field>
                            <Button className="first warning" onClick={this.onCancel} type="button">Aktion abbrechen</Button>
                            <Button className="success" type="submit">Stream Channel löschen</Button>
                        </FormStyled>
                    </Form>
                </Formik>
            </div>
        );
    }
}

export default DeleteChannel;